import axios, { AxiosError } from 'axios';
import { API_BASE_URL, TENANT_ID } from '@libs/config';
import { clearUserLocalData } from '@libs/localStorage';

const createRequest = (tenantId?: string | null) => {
  if (tenantId) {
    localStorage.setItem('ax_tenantId', tenantId);
  }
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      ...(tenantId ? { 'X-Tenant-Id': tenantId } : {}),
      ...(TENANT_ID ? { 'X-Tenant-Id': TENANT_ID } : {}),
    },
  });
};

const tenantId = localStorage.getItem('ax_tenantId');
export let request = createRequest(tenantId);

export const applyTenantId = (tenantId?: string) => {
  if (tenantId) {
    request = createRequest(tenantId);
  }
  return request;
};

export const updateToken = (token: string | null) => {
  if (!token) {
    request.defaults.headers['Authorization'] = null;
    return;
  }
  request.defaults.headers['Authorization'] = `Bearer ${token}`;
};

const initialToken = localStorage.getItem('token');
updateToken(initialToken);

/**
 * Catch the unauthorized Request
 */
request.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      clearUserLocalData();
      // @ts-expect-error `string` is assignable to location
      window.location = '/login';
    }

    return Promise.reject(error);
  },
);
